import * as betprofessor from './Favorites.styles.betprofessor';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
};
